import React from "react";
import "./Footer.css";

export default function Footer(props: {
  enabled: boolean;
  onClick: () => void;
}) {
  return (
    <div className="FooterContainer">
      <div className="FooterSpacer" />
      <button
        type="button"
        onClick={props.onClick}
        className="btn btn-outline-primary"
      >
        next
      </button>
    </div>
  );
}
